import { RoutesNavigation } from "./routes";
import { AuthProvider } from "./contexts";
import { ToastContainer } from "react-toastify";
import { useEffect } from "react";
import "./assets/css/App.css";
import "./assets/css/custom.css";
import "./styles/variables.css";
import "./styles/layout.css";
import "./styles/tailwind.css";
import "react-toastify/dist/ReactToastify.css";

export default function App() {
    useEffect(() => {
        // Ocultar preloader cuando la aplicación se cargue
        const preloader = document.getElementById("custom-preloader");
        if (preloader) {
            setTimeout(() => {
                preloader.classList.add("hidden");
                // Opcionalmente, eliminar el preloader del DOM después de la animación
                setTimeout(() => {
                    preloader.remove();
                }, 500);
            }, 1000);
        }
    }, []);

    return (
        <AuthProvider>
            <RoutesNavigation />
            <ToastContainer
                position="top-right"
                theme="colored"
                autoClose={5000}
                hideProgressBar
                closeOnClick
            />
        </AuthProvider>
    );
}
